export default __webpack_public_path__ + "static/media/ui_illustration_post_cover_skeleton.3530a138.svg";